// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "a435d56f",
    "hash": "a435d56f",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "a435d56f",
    "semverString": null,
    "version": "2026.4.0.5"
};
/* tslint:enable */
